import { useEffect, useLayoutEffect, useState } from "react";
import axios from "axios";
import { routes } from "../../../../gen/General";
import { CarouselItem } from "reactstrap";
import DOMPurify from "dompurify";
import {
    ProdesegButton,
    ProdesegButtonEnumSizes,
    ProdesegButtonEnumTypes,
} from "../../../../components/ProdesegButton/ProdesegButton";
import { Banner } from "../../../../coms/types/banner.types";
import { ReactComponent as IconFlechaRightUp } from "../../../../assets/img/icon/flecha_right_up.svg";
import { ID_CARD_ITEM } from "../../menu/menu-items.constants";
import { usePolicyMenuStore } from "../../../../store/policy-menu.store";
import { ProdesegVideo } from "../../../../components/ProdesegVideo";
import { useBoolean } from "../../../../custom-hooks/useBoolean";

export const useProdesegAnnouncement = () => {
    const { tabIndex } = usePolicyMenuStore();
    const [banners, setBanners] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [isCardDisabled, setIsCardDisabled] = useState(false);
    const { value: isPlaying, setTrue: setPlayingTrue, setFalse: setPlayingFalse } = useBoolean();

    useEffect(() => {
        let isMounted = true;
        axios
            .get(routes.apiVam + "/banner/obtener/banner")
            .then(resp => {
                const bannersResponse = resp.data.itemsGen;
                if (!isMounted) return;
                setBanners(bannersResponse);
            })
            .catch(console.error);

        return () => {
            isMounted = false;
        };
    }, []);

    useLayoutEffect(() => {
        handleCardDisabled();
    }, [tabIndex]);

    const next = () => {
        if (animating || banners.length < 2) return;
        const nextIndex = activeIndex === banners.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating || banners.length < 2) return;
        const nextIndex = activeIndex === 0 ? banners.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const openExternalUrl = (url = "") => window.open(url);

    const getCardItem = () => {
        return document.getElementById(ID_CARD_ITEM);
    };

    const openBenefitCard = () => {
        const cardItem = getCardItem();
        cardItem?.click();
    };

    const handleCardDisabled = () => {
        const cardItem = getCardItem();
        const isDisabled = cardItem?.getAttribute("data-disabled");
        setIsCardDisabled(!cardItem || isDisabled === "true");
    };

    const bannerSlides = banners
        .map((banner: Banner, index) => {
            const isVideo = banner.srcType === "2";
            return (
                <CarouselItem key={index} onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)}>
                    <div className="d-flex flex-column gap-4 pl-4 pr-4-2">
                        {!!banner.src && (
                            <div
                                className="announcement__image overflow-hidden d-flex align-items-center"
                                style={{ backgroundColor: isVideo ? "black" : "" }}
                            >
                                {isVideo ? (
                                    <ProdesegVideo
                                        src={banner.src}
                                        onPlay={setPlayingTrue}
                                        onPause={setPlayingFalse}
                                        onEnded={setPlayingFalse}
                                    />
                                ) : (
                                    <img src={banner.src} alt="Imagen del banner" />
                                )}
                            </div>
                        )}
                        {!!banner.title && (
                            <div
                                className={"h6 m-0 text-primary"}
                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(banner.title) }}
                            />
                        )}
                        {!!banner.content && (
                            <div className="announcement__description text-neutral-900">
                                <div
                                    className={"pr-1"}
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(banner.content) }}
                                />
                            </div>
                        )}
                        {!!banner.buttonText && (
                            <div>
                                <ProdesegButton
                                    type={ProdesegButtonEnumTypes.Light}
                                    size={ProdesegButtonEnumSizes.Small}
                                    Icon={IconFlechaRightUp}
                                    hideIconStart
                                    onClick={() =>
                                        banner.buttonType === "2"
                                            ? openBenefitCard()
                                            : openExternalUrl(banner.buttonUrl)
                                    }
                                    isDisabled={banner.buttonType === "2" && isCardDisabled}
                                >
                                    {banner.buttonText}
                                </ProdesegButton>
                            </div>
                        )}
                    </div>
                </CarouselItem>
            );
        })
        .reverse();

    return {
        banners,
        activeIndex,
        setActiveIndex,
        animating,
        setAnimating,
        next,
        previous,
        openExternalUrl,
        bannerSlides,
        isPlaying,
    };
};
